import { render } from "./Loader.vue?vue&type=template&id=0275ed62&scoped=true&ts=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=0275ed62&lang=scss&scoped=true"
import "./Loader.vue?vue&type=style&index=1&id=0275ed62&lang=css"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0275ed62"]])

export default __exports__